// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1Gv9w","col":"styles_col__26sG2","fulfillmentStatus":"styles_fulfillmentStatus__3sHxa","emailCol":"styles_emailCol__6Wuhw"};